import { render, staticRenderFns } from "./TeacherRetrievePass.vue?vue&type=template&id=7d66bcae&scoped=true&"
import script from "./TeacherRetrievePass.vue?vue&type=script&lang=js&"
export * from "./TeacherRetrievePass.vue?vue&type=script&lang=js&"
import style0 from "./TeacherRetrievePass.vue?vue&type=style&index=0&id=7d66bcae&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d66bcae",
  null
  
)

export default component.exports